import React from 'react';
import { useIntl } from 'react-intl';
import { SchemaRenderer } from 'volto-fzj-internet/components';

import { HighlightSchema } from './schema';

const HighlightData = (props) => {
  const { block, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = HighlightSchema({ ...props, intl });

  return (
    <SchemaRenderer
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        const additionalData = id === 'alt' ? { alt_ai_generated: false } : {};

        onChangeBlock(block, {
          ...data,
          [id]: value,
          ...additionalData,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

export default HighlightData;
